import axios from "axios";
import router from "@/router";
import i18n from "../../i18n";
import moment from "moment";
export default {
  state: {
    qnaStatus: null,
    qnaKeyword: "",
    wrongAnswerCount: 0,
    court: "",
    faqCategory: "",
    isThinking: false,
    requestQna: true,
  },
  getters: {
    getQnaStatus: (state) => state.qnaStatus,
    getQnaKeyword: (state) => state.qnaKeyword,
    getWrongAnsCount: (state) => state.wrongAnswerCount,
    getCourt: (state) => state.court,
    getFaqCategory: (state) => state.faqCategory,
    getIsThinking: (state) => state.isThinking,
    getRequestQna: (state) => state.requestQna,
  },
  mutations: {
    setQnaStatus(state, status) {
      state.qnaStatus = status;
    },
    setQnaKeyword(state, keyword) {
      state.qnaKeyword = keyword;
    },
    setWrongAnswerCount(state, count) {
      state.wrongAnswerCount = count;
    },
    setCourt(state, court) {
      state.court = court;
    },
    setFaqCategory(state, category) {
      state.faqCategory = category;
    },
    setIsThinking(state, status) {
      state.isThinking = status;
    },
    setRequestQna(state, status) {
      state.requestQna = status;
    },
  },
  actions: {
    requestQnA({ getters, dispatch, commit }, transcript) {
      let language = "";
      if (getters.isThinking) {
        commit("setSpeechTranscript", transcript);
        commit("setTextBubbleText", transcript);
      }
      console.log("Value of is thinking: ", getters.getIsThinking);
      // Request to QNA

      if (getters.getCurrentLanguage === "en") {
        language = "english";
      } else if (getters.getCurrentLanguage === "es-US") {
        language = "spanish";
      }

      let data = JSON.stringify({
        question: transcript,
        lang: language,
        client: "mdcourts",
        type: getters.getKioskProfile.data().locationCode.slice(0, -2),
      });
      console.log("Request to the AI: ", data);
      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: "https://zjul4g7rfl.execute-api.us-east-1.amazonaws.com/stage/api/query",
        data: data,
        headers: {
          "Content-Type": "application/json",
        },
      };
      commit("setIsThinking", true);
      commit("setTextBubbleText", i18n.t("isThinking"));
      axios
        .request(config)
        .then((response) => {
          console.log("Response from QNA:  ", response.data);
          const qnaAnalytics = {
            timeStamp: new Date(),
            kioskID: getters.getKioskId,
            transcript: transcript,
            result: response.data,
          };
          commit("setTouchRequest", {
            module: "QnA",
            action: transcript,
            response: response.data,
            timeStamp: new Date(),
            requestType: "Speech",
          });

          dispatch("addQnaDatatoStrapi", qnaAnalytics);
          dispatch("generateAnswer", response.data);
        })
        .catch((error) => {
          commit("setIsThinking", false);
          console.log(error);
        });
    },
    generateAnswer({ dispatch, commit, getters }, result) {
      console.log("Value of is thinking 2:  ", getters.getIsThinking);
      //setTimeout(() => {  }, 250)
      if (getters.getIsThinking) {
        commit("setIsThinking", false)
        router.push("/");
        commit("setQnaStatus", false);
        const metadata = result.answer.intent;
        const ansObj = result.answer;
        commit("setDefaultBubbleText", false);
        commit("closeOptionsViewer");
        switch (metadata) {
          case "1":
            var menuName = ansObj.metadata.path;
            router.addRoute({
              path: menuName.toLowerCase(),
              component: () => import("@/views/" + menuName),
            });
            if (router.currentRoute.path !== menuName) {
              router.push(menuName).then(() => {
                commit("setQnaKeyword", "");
                dispatch("avatarSpeak", ansObj.response);
                let page = i18n
                  .t("homepages")
                  .filter((page) => page.pageType[0].pathName === menuName);
                commit("setPageHeader", page[0].pageType[0].pageHeader);
              });
            } else {
              commit("setQnaKeyword", "");
              dispatch("avatarSpeak", ansObj.response);
            }
            break;

          case "3":
            console.log("Map Path: ", ansObj.metadata.mappath);
            try {
              var map = getters.getMaps.get(
                ansObj.metadata.mappath.toLowerCase()
              );
              console.log("Map Found English: ", map);
              var mapPath = i18n.t("maps").filter(map1 => map1.displayPosition === map.displayPosition)
              console.log("Map Found Spanish: ", mapPath);
              window.loadText(
                mapPath[0].speech,
                getters.getAvatarLangCodes.voiceId,
                getters.getAvatarLangCodes.langId,
                getters.getAvatarLangCodes.engineId
              );
              var floorName = i18n
                .t("floors")
                .filter((floor) => floor.floorNumber === mapPath[0].mapFloor);

              dispatch("avatarSpeak", mapPath[0].speech);
              dispatch("openImageViewer", {
                name: mapPath[0].mapName,
                url: mapPath[0].mapImage,
                floor: floorName[0].floorName,
                showQR: false,
                qrUrl: "",
              });
            } catch (e) {
              mapPath = getters.getMaps.get(
                getters.getDefaultLocation.toLowerCase()
              );
              floorName = i18n
                .t("floors")
                .filter((floor) => floor.floorNumber === mapPath.mapFloor);
              dispatch("avatarSpeak", i18n.t("mapNotFound"));
              dispatch("openImageViewer", {
                name: mapPath.mapName,
                url: mapPath.mapImage,
                floor: floorName[0].floorName,
                showQR: false,
                qrUrl: "",
              });
            }

            break;

          case "4":
            window.loadText(
              ansObj.response,
              getters.getAvatarLangCodes.voiceId,
              getters.getAvatarLangCodes.langId,
              getters.getAvatarLangCodes.engineId
            );
            dispatch("avatarSpeak", ansObj.response);
            break;
          case "jurymap":
            var mapName;
            var juryMapName = ansObj.metadata.mapname;
            if (ansObj.metadata.maptitle === "jury enquiry") {
              mapName = "Jury Enquiry";
            } else {
              mapName = "Jury Orientation";
            }

            commit("setJuryImageViewer", {
              name: mapName,
              mapname: juryMapName,
              show: true,
            });
            dispatch("avatarSpeak", ansObj.answer);
            break;
          case "2":
            window.loadText(
              ansObj.response,
              getters.getAvatarLangCodes.voiceId,
              getters.getAvatarLangCodes.langId,
              getters.getAvatarLangCodes.engineId
            );
            commit("setQnaKeyword", "");
            if (router.currentRoute.path !== "/faqs") {
              router.push("/faqs");
            }
            commit("setPageHeader", "Frequently Asked Questions");
            dispatch("avatarSpeak", ansObj.response);
            var linkId = ansObj.metadata.linkid;
            commit("setQnaKeyword", linkId);

            break;

          case "0":
            var followupList = [];
            window.loadText(
              ansObj.response,
              getters.getAvatarLangCodes.voiceId,
              getters.getAvatarLangCodes.langId,
              getters.getAvatarLangCodes.engineId
            );
            if (getters.getKioskProfile.data().locationCode === "charlescc") {
              followupList = i18n.t("whatcanyoudocharles").split(",");
            } else if (
              getters.getKioskProfile.data().locationCode === "howardcc"
            ) {
              followupList = i18n.t("whatcanyoudohoward").split(",");
            } else {
              followupList = i18n.t("whatcanyoudocatonsville").split(",");
            }
            var prompts = followupList;
            var followUp = [];
            dispatch("avatarSpeak", ansObj.response);
            console.log(
              "Follow up question when metadata is followup: ",
              prompts
            );
            prompts.forEach((item) => followUp.push(item));
            dispatch("openOptionsViewer", {
              dialogHeader: i18n.t("selectOptionMsg"),
              dialogData: followUp,
            });
            break;
          default:
            mapPath = getters.getMaps.get(
              getters.getDefaultLocation.toLowerCase()
            );
            floorName = i18n
              .t("floors")
              .filter((floor) => floor.floorNumber === mapPath.mapFloor);
            dispatch("openImageViewer", {
              name: mapPath.mapName,
              url: mapPath.mapImage,
              floor: floorName[0].floorName,
              showQR: false,
              qrUrl: "",
            });
            dispatch("avatarSpeak", i18n.t("kbError"));
            break;
        }
      }
    },
  },
};
